// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IngbNzomc8G5XpJtLgfE input {\n  display: none;\n}\n.IngbNzomc8G5XpJtLgfE .q9lgT_3Cf1nI4f4dXEQt {\n  cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://./node_modules/@tencent/dz-bricks-ui/es/components/UIUpload/index.less"],"names":[],"mappings":"AAEA;EAEI,aAAA;AAFJ;AAAA;EAKI,eAAA;AAFJ","sourcesContent":["@import \"@tencent/dz-bricks-ui/styles/index.less\";\n\n.upload-container {\n  input {\n    display: none;\n  }\n  .upload-content {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upload-container": "IngbNzomc8G5XpJtLgfE",
	"upload-content": "q9lgT_3Cf1nI4f4dXEQt"
};
export default ___CSS_LOADER_EXPORT___;
